import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  { path: '/', name: 'home', component: () => import('../views/Home.vue') },
  { path: '/list', name: 'list', component: () => import('../views/Content.vue') }
]

const router = new Router({
  mode: 'history', // 去掉url中的#
  base: `/${process.env.VUE_APP_BASE_URL}/`,
  routes
})

export default router
